export default __webpack_public_path__ + "static/media/gameplay-hero-img.e972377c.png";